<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 text-center">
        <h4 style="color:#ff7900"></h4>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12">
        <div class="card">
          <div class="card-content">
            <h4>{{ $t('hello')  }} {{ ls.get('auth.user.name') }}</h4>{{ $t('please_choose_page') }}<br/>
            
            <div class="clearfix"></div>
            <router-link
              :to="{path: '/portal/fileservice'}"
              tag="div"
              class="col-md-5 col-sm-5 col-xs-6 btn btn-primary padding-xs"
            >
              <h5>{{ $t('fileservice') }}</h5>
              <i class="fas fa-exchange-alt fa-4x"></i>
            </router-link>
            <router-link
              :to="{path: '/portal/tickets'}"
              tag="div"
              class="col-md-5 col-sm-5 col-xs-6 btn btn-primary padding-xs"
            >
              <h5>{{ $t('support') }}</h5>
              <i class="fas fa-question-circle fa-4x"></i>
            </router-link>
            <div class="clearfix"></div>
            <router-link
              :to="{path: '/portal/fileservice/upload'}"
              tag="div"
              class="col-md-5 col-sm-5 col-xs-6 btn btn-primary padding-xs"
            >
              <h5>{{ $t('upload_now') }}</h5>
              <i class="fas fa-upload fa-4x"></i>
            </router-link>
            <router-link
              :to="{path: '/portal/credits'}"
              tag="div"
              class="col-md-5 col-sm-5 col-xs-6 btn btn-primary padding-xs"
            >
              <h5>{{ $t('credits') }}</h5>
              <i class="fas fa-hand-holding-usd fa-4x"></i>
            </router-link>
            <div class="clearfix"></div>
            <span v-if="openingtimes">
              <h4>{{ $t('openingtimes') }}</h4>
              <table class="table table-hover">
                <thead>
                  <th>{{ $t('day') }}</th>
                  <th>{{ $t('open') }}</th>
                  <th>{{ $t('closed') }}</th>
                </thead>
                <tbody>
                  <tr v-for="timeItem in openingtimes">
                    <td>{{timeItem.day}}</td>
                    <td>{{timeItem.open}}</td>
                    <td>{{timeItem.closed}}</td>
                  </tr>
                </tbody>
              </table>
              {{ $t('all_times_local_office_times') }}
               ({{timezone}}) - {{ $t('the_clock_left_local_time') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-8 col-xs-12 text-center">
        <div class="card">
          <div class="card-content">
            <v-server-table
              :url="tableDataUrl"
              :columns="columns"
              ref="fileserviceTable"
              :options="options"
            >
              <template slot="status" slot-scope="props">
                <span class="text-center blockdisplay statusIcon">
                  <span v-if="props.row.status == 'completed'" class="text-success">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  <span v-if="props.row.status == 'pending'" class="text-pending">
                    <i class="fas fa-clock"></i>
                  </span>
                  <span v-if="props.row.status == 'canceled'" class="text-error">
                    <i class="fas fa-times"></i>
                  </span>
                </span>
              </template>

              <template
                slot="serieName"
                slot-scope="props"
              >{{ props.row.brandName }} {{ props.row.serieName }} {{ props.row.engineName}}</template>
            </v-server-table>
            <router-link :to="{path: '/portal/fileservice'}" tag="div" class="btn btn-primary">
              <i class="fas fa-exchange-alt"></i> {{ $t('go_to_fileservice_view_all') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      tableDataUrl: APIURL + "/files",
      columns: ["status", "credits", "serieName", "product"],
      options: {
        headings: {
          status: this.$t('Status'),
          credits: this.$t('Credits'),
          product: this.$t('products'),
          serieName: this.$t('Vehicle'),
        },
        perPage: 5,
        rowClassCallback: function(row) {
          if (row.status == "pending") {
            return "fileOverviewRowPending";
          }
          if (row.status == "completed") {
            return "fileOverviewRowFinished";
          }
          if (row.status == "canceled") {
            return "fileOverviewRowCanceled";
          }
        },
        openingtimes: {},
        timezone: ''
      }
    };
  },
  computed: {
    ls: () => {
      return Ls;
    }
  },
  beforeMount () {
    var timezone = 'Europe/Madrid';
    if(!typeof(timezone) !== 'undefined') {
      this.timezone = timezone
    }

    var openingtimeData = Webservice.getSetting('openingtimes');
    if(!typeof(openingTimeData) !== 'undefined') {
      this.openingtimes = JSON.parse(openingtimeData);
    }
  }
};
</script>
<style scoped>
.VueTables__search-field,
.VuePagination__count {
  display: none !important;
  visibility: hidden;
}
.btn {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Home.vue